import { render, staticRenderFns } from "./SelectAdminUser.vue?vue&type=template&id=6b658f8b"
import script from "./SelectAdminUser.vue?vue&type=script&lang=ts"
export * from "./SelectAdminUser.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports